module.exports = __webpack_public_path__ + "static/flags/FK-f2a5b817b6df34bb6e07317109a771aa.gif";